import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { AddressTreeStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Reseet address tree state and unset key storage
 */
export const addressTreeUnsetKeyStorage = createAction(
  AddressTreeStoreAction.ADDRESS_TREE_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const addressTreeLoadInitStartAction = createAction(
  AddressTreeStoreAction.ADDRESS_TREE_LOAD_INIT_START
);

/**
 * Action to load full list of addressTrees
 */
export const addressTreeLoadListFromApiAction = createAction(
  AddressTreeStoreAction.ADDRESS_TREE_LOAD_FROM_API
);

/**
 * Action to load last modified list of addressTrees
 */
export const addressTreeLoadLastModifiedFromApiAction = createAction(
  AddressTreeStoreAction.ADDRESS_TREE_LOAD_LAST_MODIFIED_FROM_API,
  props<{ addressTreeObject: GenericApiData }>()
);

/**
 * Action addressTree load success
 */
export const addressTreeLoadSuccessAction = createAction(
  AddressTreeStoreAction.ADDRESS_TREE_LOAD_SUCCESS,
  props<{ addressTreeObject: GenericApiData }>()
);

/**
 * Action addressTree load error
 */
export const addressTreeLoadErrorAction = createAction(
  AddressTreeStoreAction.ADDRESS_TREE_LOAD_ERROR
);
